import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import MenuItem from '../../Models/MenuItem';
import GetMenuItemResponse from '../Responses/MenuItemResponse';
import GetPaginatedResponse from '../Responses/PaginatedResponse';

class MenuItemsApi extends AbstractCRMApi {
    public endpoint: string = 'menu_items';

    public getById(id: number): Promise<MenuItem> {
        return this.get(`/${id}`).then((response: AxiosResponse<GetMenuItemResponse>) =>
            MenuItemsApi.mapDataToMenuItemClass(response.data)
        );
    }

    public getAll(page: number = 1, config?: AxiosRequestConfig): Promise<GetPaginatedResponse<MenuItem>> {
        return this.get('', {
            ...config,
            params: { ...config?.params, page },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetMenuItemResponse>>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, MenuItem);
        });
    }

    public store(menuItem: MenuItem): Promise<MenuItem> {
        return this.post('', menuItem).then((response: AxiosResponse<GetMenuItemResponse>) =>
            MenuItemsApi.mapDataToMenuItemClass(response.data)
        );
    }

    public update(menuItem: MenuItem): Promise<MenuItem> {
        return this.patch(`/${menuItem.id}`, menuItem).then((response: AxiosResponse<GetMenuItemResponse>) =>
            MenuItemsApi.mapDataToMenuItemClass(response.data)
        );
    }
}

export default new MenuItemsApi();
